import { DevelopDeploy } from "../widgets/developDeploy/developDeploy.js";

let fdDevelopDeploy = document.getElementById('fdDevelopDeploy');
let opts = {};
let fdDevelopDeployWidget = new DevelopDeploy(fdDevelopDeploy, opts);